import api from './api';

const setAuthToken = token => {
  if (token) {
    // Set axios auth header
    api.defaults.headers.common['x-auth-token'] = token;

    // Also store in local storage for persistence
    localStorage.setItem('token', token);
  } else {
    // Remove from axios defaults
    delete api.defaults.headers.common['x-auth-token'];

    // Remove from local storage
    localStorage.removeItem('token');
  }

  // For debugging
};

export default setAuthToken;
